<div class="mt-5 mb-2 flex">
  <div class="font-bold text-xl">{{'handover.main-images' |translate}}</div>
</div>
<div *ngIf="hasDescOrImages else noGeneralSection">
  <handoverm-handover-section [desc]="model?.general?.desc"
                              [images]="model?.general?.imageUrls"
                              [model]="model"></handoverm-handover-section>
</div>
<ng-template #noGeneralSection>
  <div class="tk-border-gray-2 px-5 py-4 rounded-xl">
    {{'handover.no-general-images' | translate}}
  </div>
</ng-template>
